import { coursesApi } from './courses-base.api';
import type {
	ListModulesOutput,
	GetModuleInput,
	GetModuleOutput,
	GetLessonInput,
	GetLessonOutput,
} from '../../types/modules.types';

const TAG = 'courses:modules' as const;

export const modulesEndpoints = coursesApi.injectEndpoints({
	endpoints: (builder) => ({
		listModules: builder.query<ListModulesOutput, void>({
			query: () => ({ url: 'courses/modules' }),
			providesTags: [TAG],
		}),
		getModule: builder.query<GetModuleOutput, GetModuleInput>({
			query: ({ moduleId }) => ({ url: `courses/modules/${encodeURIComponent(moduleId)}` }),
			providesTags: [TAG],
		}),
		getLesson: builder.query<GetLessonOutput, GetLessonInput>({
			query: ({ moduleId, lessonId }) => ({
				url: `courses/modules/${encodeURIComponent(moduleId)}/lessons/${encodeURIComponent(lessonId)}`,
			}),
			providesTags: [TAG],
		}),
	}),
});

export const {
	useListModulesQuery,
	useLazyListModulesQuery,
	useGetModuleQuery,
	useLazyGetModuleQuery,
	useGetLessonQuery,
	useLazyGetLessonQuery,
} = modulesEndpoints;
